import Duration from "models/Duration";
import { GenericService, Service } from "./genericService";

class DurationService
  extends GenericService<Duration>
  implements Service<Duration>
{
  constructor() {
    super("api/Duration");
  }
}

export default new DurationService();
